import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Fidelite } from "../../services/Api/swagger";

export interface FideliteState {
  listeCompteFidelite?: Fidelite[];
}

const initialState: FideliteState = {};

export const FideliteSlice = createSlice({
  name: "@@app/fidelite",
  initialState: initialState,
  reducers: {
    setListeCompteFidelite: (
      state: FideliteState,
      action: PayloadAction<Fidelite | undefined>
    ) => {
      if (action.payload) {
        state.listeCompteFidelite = state.listeCompteFidelite
          ? [...state.listeCompteFidelite, action.payload]
          : [action.payload];
      }
    },
  },
});

export const { setListeCompteFidelite } = FideliteSlice.actions;

// Selectors
export const getListeCompteFidelite = (state): Fidelite[] | undefined =>
  state.fidelite && state.fidelite.listeCompteFidelite;
